import { useStaticQuery, graphql } from "gatsby"

export const useBlogMetaData = () => {
  const blogData = useStaticQuery(
    graphql`
      query blogMetaData {
        wpPage(id: { eq: "cG9zdDoxMTM3" }) {
          title
          BlogPageFields {
            blogsContent
            blogsShowSection
            blogsSubTitle
            blogsTitle
            fieldGroupName
          }
          MetaFields {
            customPageSchema
            customSeoFocusKeyphrase
            customSeoKeywords
            customSeoMetaDescription
            customSeoMetaTitle
            customSeoRobotFollow
            customSeoRobotIndex
            fieldGroupName
            customSeoOgUrl
          }
        }
        wp {
          allSettings {
            generalSettingsUrl
          }
        }
      }
    `
  )
  return blogData
}
